<div class="user-menu__inner" (click)="onOpenUserMenu()">
  <ui-avatar
    *ngIf="user"
    [user]="user"
    class="user-menu__avatar avatar_xs">
  </ui-avatar>
  <span class="user-menu__name">{{user?.firstName}}</span>
  <lucide-icon name="chevron-down" class="user-menu__icon-arrow" [size]="16" aria-hidden="true"></lucide-icon>
</div>
<ui-adaptive-popup
  [openTrigger]="openTrigger"
  [closeTrigger]="closeTrigger"
  [matDialogConfig]="matDialogConfig"
  class="user-menu__popup">
  <ui-user-menu-popup
    [user]="user"
    [company]="company"
    [closeTrigger]="closeTrigger">
  </ui-user-menu-popup>
</ui-adaptive-popup>
